var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TaskList',{attrs:{"title":"Bank Statement","taskType":"bank_statement"}})
}
var staticRenderFns = []

export { render, staticRenderFns }